import React from "react";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import InputAdornment from "@material-ui/core/InputAdornment";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import HttpsOutlinedIcon from "@material-ui/icons/HttpsOutlined";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { Redirect } from "react-router-dom";

import backgroundImage from "../../../assets/img/login.png";
import { withStyles } from "@material-ui/styles";
import { AuthService } from "../../../services/auth.service";
import { actions } from "../../../redux/actions/alert";
import { connect } from "react-redux";
import { Card } from "@material-ui/core";

const useStyles = (theme) => ({
  root: { width: "100%" },
  image: {
    // maxHeight: "100%",
    // maxWidth: "100%",
    minWidth: "100%",
    minHeight: "100%",
    height: "99.3vh",
    width: "auto",
    objectFit: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  },
  paper: {
    width: "28vw",
    minWidth: 400,
    minHeight: 450,
    height: "60vh",
  },
  title: {
    paddingTop: 18,
    fontFamily: "Roboto",
  },
  subtitle: {
    fontFamily: "inherit",
    paddingTop: 2,
    color: "#afaeb4",
  },
  form: {
    width: "75%", // Fix IE 11 issue.
  },
  label: {
    marginTop: "1.5vh",
  },
  submit: {
    background: "#3246D3",
    boxShadow:
      "0px 2px 4px rgba(44, 39, 56, 0.08), 0px 4px 8px rgba(44, 39, 56, 0.08)",
    borderRadius: "99px",
    padding: "14px 100px ",
    marginTop: theme.spacing(4),
  },
  alert: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
    height: 50,
  },
});

class Login extends React.Component {
  componentDidMount() {
    const currentUser = AuthService.currentUserValue;

    if (currentUser && Object.values(currentUser).length) {
      console.log("should redirect");
      this.setState({ redirect: true });
    }
  }

  state = {
    credentials: {
      email: "",
      password: "",
    },
    redirect: false,
    errorService: "",
    userLogged: false,
    showAlert: false,
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { addAlert, detailAlert } = this.props;
    addAlert({ showAlert: false });

    AuthService.login(this.state.credentials)
      .then((res) => {
        this.setState({ redirect: true });
        const { token, user } = res.data;
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(user));
        this.setState({ userLogged: true });
      })
      .catch((error) => {
        const credentials = { ...this.state.credentials };
        credentials.password = "";
        this.setState({ credentials });
        addAlert({ showAlert: true });
        detailAlert({ severity: "error", message: error.msgs });
      });
  };

  handleChange = (e) => {
    const credentials = { ...this.state.credentials };
    credentials[e.target.name] = e.target.value;
    this.setState({ credentials });
  };

  render() {
    const { classes } = this.props;
    const { credentials, redirect } = this.state;

    return (
      <Grid container className={classes.root}>
        <Grid
          item
          xs={12}
          sm={5}
          md={6}
          lg={5}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Card elevation={3} className={classes.paper}>
            <Grid
              container
              direction="column"
              justify="flex-start"
              alignItems="center"
            >
              <Typography className={classes.title} component="h1" variant="h3">
                ¡Bienvenido!
              </Typography>

              <Typography className={classes.subtitle} variant="subtitle1">
                Accede a tu cuenta desde aquí
              </Typography>

              {/** TODO validate onError event validatorForm */}
              <ValidatorForm
                noValidate
                className={classes.form}
                method="POST"
                onSubmit={this.handleSubmit}
                onError={(errors) => console.log(errors)}
              >
                <Typography
                  variant="body2"
                  component={"div"}
                  className={classes.label}
                >
                  Email
                </Typography>
                <TextValidator
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  id="email"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  onChange={this.handleChange}
                  value={credentials.email}
                  validators={["required", "isEmail"]}
                  errorMessages={[
                    "El email es requerido",
                    "El email no es válido",
                  ]}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MailOutlineIcon color="primary" />
                      </InputAdornment>
                    ),
                  }}
                />

                <Typography
                  variant="body2"
                  component={"div"}
                  className={classes.label}
                >
                  Password
                </Typography>

                <TextValidator
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  name="password"
                  type="password"
                  id="password"
                  onChange={this.handleChange}
                  value={credentials.password}
                  validators={["required"]}
                  errorMessages={["El password es requerido"]}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <HttpsOutlinedIcon color="primary" />
                      </InputAdornment>
                    ),
                  }}
                />
                <Grid container direction="row" justify="center">
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                  >
                    Iniciar sesión
                  </Button>
                </Grid>
              </ValidatorForm>
            </Grid>
          </Card>
        </Grid>

        <Grid
          item
          xs={12}
          sm={7}
          md={6}
          lg={7}
          style={{
            overflow: "hidden",
          }}
        >
          <img src={backgroundImage} className={classes.image} alt="" />
        </Grid>
        {redirect && <Redirect to="dashboard" />}
      </Grid>
    );
  }
}

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default withStyles(useStyles)(connect(undefined, dispatch)(Login));
